import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container, Row, Col, Alert, InputGroup } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './style.css';
import UserService from '../../services/UserService';
import packageJson from '../../../package.json';

const LoginPage = ({ setIsLoggedIn }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const currentVersion = packageJson.version;
    const savedVersion = localStorage.getItem('appVersion');

    if (!savedVersion || savedVersion !== currentVersion) {
      localStorage.clear();
      sessionStorage.clear();
      document.cookie.split(';').forEach((cookie) => {
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
      });

      localStorage.setItem('appVersion', currentVersion);

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const result = await UserService.login(username, password);

    if (result.success) {
      setIsLoggedIn(true);
      navigate('/');
    } else {
      setError(result.message);
    }
  };

  return (
    <div className="login-body">
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Row className="login-container p-4 rounded shadow">
          <Col xs={12} className="text-center mb-3">
            <img src="/images/logo2.png" alt="Logo" className="logo" />
          </Col>

          <Col xs={12}>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="username" className="mb-3">
                <Form.Label className="form-label">Tên đăng nhập:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nhập mã nhân viên"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group controlId="password" className="mb-3">
                <Form.Label className="form-label">Mật khẩu:</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Nhập mật khẩu"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <InputGroup.Text className="no-border transparent" onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>

              {error && <Alert variant="danger">{error}</Alert>}

              <Button type="submit" variant="danger" className="w-100 button">Đăng nhập</Button>
            </Form>
          </Col>

          <Col xs={12} className="text-center mt-4 help-info">
            <p><strong>Thông tin trợ giúp:</strong></p>
            <p><span>Nguyễn Hữu Vinh</span> - SĐT/Zalo - 0906793604</p>
          </Col>

          <Col xs={12} className="text-center mt-3">
            <a href="/NOCTTKT3.apk" target="_blank" rel="noreferrer noopener" className="app-link">
              Tải ứng dụng Android
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginPage;
